import { Link } from "react-router-dom";
import List from "../../layout/List";
import Listitem from "../../layout/Listitem";

const MyAccount = () => {
  return (
    <div className="mt-[60px] w-[304px] border-b border-solid border-darkGreen border-opacity-60">
      <div className="mb-6">
        <h3 className="bg-primary py-4 px-5 font-pop text-xl font-medium text-white">
          MY ACCOUNT
        </h3>
      </div>
      <div className="flex justify-center">
        <Link to="/create-auctionlist-form">
          <img src="/assets/images/buttonnav.png" alt="buttonnav" />
        </Link>
      </div>
      <div className="mt-7">
        <List className="font-regular px-8 font-pop text-sm text-darkGreen text-opacity-60">
          <Listitem
            className="pb-4"
            itemname="Active Listing (5)"
            href="/user/active"
          />
          <Listitem
            className="pb-4"
            itemname="Expired Listing (5)"
            href="/user/expired"
          />
          <Listitem
            className="pb-4"
            itemname="Items Bidding On (5)"
            href="/user/bidding-on"
          />
          <Listitem
            className="pb-4"
            itemname="Auctions Won (5)"
            href="/user/won-and-bought"
          />
          <Listitem
            className="pb-4"
            itemname="Messages (5)"
            href="/user/message"
          />
          <Listitem
            className="pb-4"
            itemname="My Listing Offers (5)"
            href="/user/listing-offers"
          />
          <Listitem
            className="pb-4"
            itemname="Unpaid Fees (5)"
            href="/user/unpaid"
          />
          <Listitem
            className="pb-4"
            itemname="Sold Items(7)"
            href="/user/sold-items"
          />
          <Listitem
            className="pb-4"
            itemname="Watch List (3)"
            href="/user/watch-list"
          />
          <Listitem
            className="pb-4"
            itemname="Pending Reviews(5)"
            href="/user/reviews-pending"
          />
          <Listitem
            className="pb-4"
            itemname="Listing Filters (6)"
            href="/user/listing-filters"
          />
          <Listitem
            className="pb-4"
            itemname="Create Listing Filter"
            href="/user/create-listing-filters"
          />
          <Listitem
            className="pb-4"
            itemname="Account Information"
            href="/user/info"
          />
          <Listitem
            className="pb-4"
            itemname="Auction Fees Chart"
            href="/user/fee-charts"
          />
          <Listitem
            className="pb-4"
            itemname="Create Business Listing"
            href="/business-listing-form"
          />
          <Listitem
            className="pb-4"
            itemname="My Business Listings (2)"
            href="/user/my-business"
          />
          <Listitem
            className="pb-4"
            itemname="Report Buyer/Seller"
            href="/user/report"
          />
        </List>
      </div>
    </div>
  );
};

export default MyAccount;
